import React from 'react';
import {StyleSheet, View} from 'react-native';

import {InformationContentType} from '../../../models/navigationTypes';
import {useRewardsTermsAndConditionsPopper} from '../../../screens/rewards/TermsAndConditions';
import {rewardsMarketingName} from '../../../utils/rewards';
import Text from '../../themed/Text';
import CheckBox, {CheckBoxProps} from '../CheckBox';
import RewardsProgramImage from '../ProgramImage';

type OptInProps = Pick<CheckBoxProps, 'onChange' | 'checked'>;

export default function OptIn({checked, onChange}: OptInProps) {
  const {textNode, dialogNode} = useRewardsTermsAndConditionsPopper({
    text: 'Loyalty Terms and Conditions',
    contentType: InformationContentType.REWARDS_PROGRAM_TERMS_AND_CONDITIONS,
  });
  return (
    <View>
      <View style={[styles.container]}>
        <RewardsProgramImage
          style={{
            marginVertical: 0,
            width: 61,
            height: 36,
            flexShrink: 0,
            alignSelf: 'auto',
          }}
          variant="onLight"
        />

        <View style={{flexShrink: 1, gap: 10}}>
          <Text>
            Opt-in to our Rewards program and start enjoying free member
            benefits all at your fingertips.
          </Text>
          <CheckBox
            checked={checked}
            onChange={onChange}
            text="Sign me up for rewards"
          />
        </View>
      </View>
      <Text variant="body2" style={{marginTop: 20, fontStyle: 'italic'}}>
        When signing up to the {rewardsMarketingName} program, you agree with
        the {textNode}
      </Text>
      {dialogNode}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#F6FBFF',
    flexDirection: 'row',
    paddingVertical: 16,
    paddingHorizontal: 10,
    gap: 14,
    alignItems: 'flex-start',
  },
});
